import { createContext, useContext, useEffect } from "react";

import { useEvents } from "./EventsProvider";
import { useLocation } from "react-router-dom";
import { setTravelApiToken } from "../../_config/travel";
import { setApiToken } from "_config/http";

export const AuthContext = createContext(null);

export const AuthSafraProvider = ({ children }) => {
    const { authData } = useEvents();
    const { token, userData, balance } = authData || {};
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const customerId = params.get('uuid') || userData?.uuid;
    const customerBalance = params.get('balance') || balance;

    useEffect(() => {
        if (token) {
            setTravelApiToken(token);
            setApiToken(token);
        }
    }, [token]);

    let customerParams = {
        customer_parent: customerId,
        customer_balance: customerBalance
    };

    Object.entries(customerParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== 'undefined' && value !== 'null') {
            localStorage.setItem(key, value);
        }
    });

    return (
        <AuthContext.Provider value={{
            customerId: userData?.uuid,
            userData,
            balance,
            token
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);